import styled from '@emotion/styled'
import { faBookAtlas, faDumbbell, faHomeLg, faKey, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import Breakpoint from '../../../Breakpoint'
import { useLangSelected } from '../../../hooks/useLangSelected'
import AdminContainer from '../../admin/AdminContainer'
import MainLink from '../MainLink'

export const CoachSideBar = ({ children }: { children: ReactNode }) => {
    const location = useLocation()

    let lng = useLangSelected()

    const { t } = useTranslation()

    return (
        <>
            <Sidebar>
                <SidebarLink
                    to={`${lng}/bva-coach`}
                    className={location.pathname === `/${lng}/bva-coach` ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faHomeLg} />{' '}
                    {window.innerWidth > +Breakpoint.LAPTOP_XS.split('p')[0] && t('sidebar.admin.dashboard')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/mes-membres`}
                    className={location.pathname.includes(`/${lng}/bva-coach/mes-membres`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faUser} />{' '}
                    {window.innerWidth > +Breakpoint.LAPTOP_XS.split('p')[0] && t('coach.my-members')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/competences`}
                    className={location.pathname.includes(`/${lng}/bva-coach/competences`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faBookAtlas} />{' '}
                    {window.innerWidth > +Breakpoint.LAPTOP_XS.split('p')[0] && t('coach.skills')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/exercises`}
                    className={location.pathname.includes(`/${lng}/bva-coach/exercises`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faDumbbell} />{' '}
                    {window.innerWidth > +Breakpoint.LAPTOP_XS.split('p')[0] && 'Exercices'}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/modifier-mon-mot-de-passe`}
                    className={location.pathname === `/${lng}/bva-coach/modifier-mon-mot-de-passe` ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faKey} />{' '}
                    {window.innerWidth > +Breakpoint.LAPTOP_XS.split('p')[0] && t('sidebar.member.password')}
                </SidebarLink>
            </Sidebar>
            <AdminContainer>{children}</AdminContainer>
        </>
    )
}

const SidebarLink = styled(MainLink)`
    display: flex;
    align-items: center;

    &.active {
        border: none;
    }

    & * {
        margin-right: 8px;

        @media (max-width: ${Breakpoint.TABLET_L}) {
            justify-content: center;
            margin-right: 0;
        }

        @media (max-width: ${Breakpoint.PHONE}) {
            height: 3rem;
        }
    }

    &:active {
        transform: scale(0.95);
    }

    @media (max-width: ${Breakpoint.TABLET_L}) {
        justify-content: center;
    }
`

const Sidebar = styled.div`
    display: flex;
    flex-direction: column;
    width: 15%;
    background-color: white;
    min-height: calc(100vh - 166px);
    box-shadow: 0px 0px 4px black;
    box-sizing: border-box;
    padding: 16px;
    padding-left: 3%;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        padding: 24px 0;
    }
`

export default CoachSideBar
